<template>
  <main class="main" id="main">

    <!---------------Blog-------------------->

    <div class="main_top_line">
      <div class="container">
        <div class="top_line_inner">
          <h1>Мы просто заново изобрели доставку еды!</h1>
          <p>сервис доставки еды ХОЧУ-ПОЕСТЬ предлагает Вам увеличить прибыль Вашего ресторана</p>
        </div>
      </div>
    </div>

    <section class="section s-restaurants_form">
      <div class="container">

        <div class="restaurant_form">

          <div class="main_form_box">
            <div class="form_title">
              <h1>
                Схема работы простая и понятная:
                <br>Мы вам - заказы, Вы нам - % от заказа. Какой?
                Решаете Вы!
              </h1>
            </div>

            <div class="input_order">
              <div class="placeholder">
                Город <span>*</span>
              </div>

              <input type="text" name="" class="order" v-model="geo.city" readonly>
            </div>

            <div class="input_order">
              <div class="placeholder">
                Название ресторана <span>*</span>
              </div>

              <input type="text" name="" class="order" v-model="restaurant_name">
            </div>

            <div class="input_order">
              <div class="placeholder">
                Веб-сайт  <span>*</span>
              </div>

              <input type="text" name="" class="order" v-model="web">
            </div>

            <div class="input_order">
              <div class="placeholder">
                Ваше имя  <span>*</span>
              </div>

              <input type="text" name="" class="order" v-model="auth.name">
            </div>

            <div class="input_order">
              <div class="placeholder">
                Тел. номер <span>*</span>
              </div>

              <input type="text" name="" class="order" v-model="auth.phone" data-inputmask="'mask': '+9(999)999-99-99'">
            </div>

            <div class="input_order">
              <div class="placeholder">
                E-mail <span>*</span>
              </div>

              <input type="text" name="" class="order" v-model="auth.email" >
            </div>

            <div class="info_agreement">
              <input type="checkbox" name="" id="data_agreement" v-model="checkbox">
              <label for="data_agreement">
                <span>
                  Я соглашаюсь с условиями обработки моих данных компанией ООО«Эчив Райт Нау» согласно положениям Федерального закона "О персональных данных"от 27.07.2006 N 152-ФЗ, а также на получение информационных сообщений от ООО «Эчив Райт Нау» в связи с выполнением настоящей заявки.
                </span>
              </label>
            </div>
            <div class="info_agreement">
              <input type="checkbox" name="" id="post_agreement" v-model="checkbox2">
              <label for="post_agreement">
                <span>
                  Я согласен на получение персональных предложений и новостей от проекта
                </span>
              </label>
            </div>
          </div>

          <div class="extra_form_toggle" id="extra_form_toggle_box" style="display:none;">
            <p><strong>?</strong> Вы можете дозаполнить анкету в любое время в личном кабинете. Не обязательно делать это прямо сейчас</p>
            <div class="btn_box">
              <span>Заполнить сейчас</span>
              <button type="button" class="choice_toggle" id="restaurant_extra_form_toggle"></button>
            </div>
          </div>
          <div class="extra_info_box">
            <div class="extra_restaurant_info">

              <div class="info_row file">
                <span class="input_description">Логотип</span>

                <input class="file_input" id="file_avatar" name="file_avatar" type="file">
                <label for="file_avatar">Прикрепить</label>
              </div>

              <div class="info_row">
                <span class="input_description">Адрес Службы доставки</span>
                <input type="text" class="max">
                <button class="post_service_adding">+</button>
              </div>

              <div class="info_row">
                <span class="input_description">Вид кухни</span>
                <select class="select_info" name="amount">
                  <option value="1">Любой</option>
                  <option value="2">Такой</option>
                </select>
              </div>

              <div class="info_row">
                <span class="input_description">Время приёма заказов</span>
                <input type="text" class="date">
                <input type="text" class="date">
              </div>

              <div class="info_row">
                <span class="input_description">Минимальная сумма заказа</span>
                <input type="text">
              </div>

              <div class="info_row">
                <span class="input_description">Стоимость доставки по зонам</span>
                <div class="notice_box">
                  <input class="max" type="text">
                  <p class="input_notice"><strong>*</strong> - прикрепите ссылку с информацией о зонах или опишите их</p>
                </div>
              </div>

              <div class="info_row">
                <span class="input_description">Бесплатная доставка от</span>
                <input type="text">
              </div>

              <div class="info_row">
                <span class="input_description">Номер call-центра</span>
                <input type="text">
              </div>

              <div class="info_row">
                <span class="input_description">Номер для смс-информирования</span>
                <input type="text">
              </div>

              <div class="info_row">
                <span class="input_description">E-mail для информирования</span>
                <input type="text">
              </div>

              <div class="info_row">
                <span class="input_description">Среднее время доставки (минут)</span>
                <input type="text">
              </div>

              <div class="info_row">
                <span class="input_description">Оплата курьеру картой</span>
                <select class="select_info" name="amount">
                  <option value="1">Любой</option>
                  <option value="2">Такой</option>
                </select>
              </div>

              <div class="info_row">
                <span class="input_description">Возможность оплаты по эквайрингу</span>
                <select class="select_info" name="amount">
                  <option value="1">Любой</option>
                  <option value="2">Такой</option>
                </select>
              </div>

              <div class="info_row">
                <span class="input_description">Скидка при самовывозе, %</span>
                <div class="notice_box">
                  <input type="text">
                  <p class="input_notice"><strong>*</strong> - если скидка не предусмотрена - укажите 0</p>
                </div>
              </div>

              <div class="info_row">
                <span class="input_description">Можно оплатить бонусами, %</span>
                <input type="text">
              </div>

              <div class="info_row">
                <span class="input_description">Скидка на День Рождения, %</span>
                <div class="notice_box">
                  <input type="text">
                  <p class="input_notice"><strong>*</strong> - если скидка не предусмотрена - укажите 0</p>
                </div>
              </div>

              <div class="info_row">
                <span class="input_description">Возможность проведения акций</span>
                <select class="select_info" name="amount">
                  <option value="1">Любой</option>
                  <option value="2">Такой</option>
                </select>
              </div>

              <div class="info_row">
                <span class="input_description">Особенности Вашего заведения</span>
                <input type="text" class="max">
              </div>

              <div class="info_row file">
                <span class="input_description">Карточка предприятия</span>

                <input class="file_input" id="file_avatar2" name="file_avatar" type="file">
                <label for="file_avatar">Прикрепить</label>
              </div>

              <div class="info_agreement">
                <input type="checkbox" name="" id="post2">
                <label for="post" id="info_label2"></label>
                Свяжитесь со мной
              </div>

              <div class="info_agreement">
                <input type="checkbox" name="" id="post">
                <label for="post" id="info_label"></label>
                Я соглашаюсь с условиями обработки моих данных компанией ООО
                «Эчив Райт Нау» согласно положениям Федерального закона "О персональных данных"
                от 27.07.2006 N 152-ФЗ, а также на получение информационных сообщений от ООО «Эчив Райт Нау»
                в связи с выполнением настоящей заявки.
              </div>

            </div>
          </div>

          <button class="menu_item_btn" @click="sendRest">Присоединиться</button>
        </div>

      </div>
    </section>

    <section class="section s-choose_us">
      <div class="container">
        <h1>ХОЧУ-ПОЕСТЬ - ЭТО ПРОСТАЯ И ПОНЯТНАЯ РАБОТА ДЛЯ ВАШЕЙ КУХНИ И ДОСТАВКИ</h1>
        <div class="choose_box">

          <div class="choose_card">
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/icon_list.svg" alt="">
            <p>четкая и понятная система расчета в реальном времени</p>
          </div>

          <div class="choose_card">
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/icon_integr.svg" alt="">
            <p>интеграция с системой заказов ресторана</p>
          </div>

          <div class="choose_card">
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/icon_group.svg" alt="">
            <p>удобные и быстрые уведомления</p>
          </div>

          <div class="choose_card">
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/icon_wallet.svg" alt="">
            <p>любой способ оплаты</p>
          </div>

          <div class="choose_card">
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/icon_ru.svg" alt="">
            <p>выгодные условия благодарности за нашу работу</p>
          </div>

        </div>
      </div>
    </section>

    <section class="section s-tab">
      <div class="container">

        <div class="tab_box">
          <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/tab.png" alt="">

          <div class="statistic">
            <div class="inner">
              <h1 class="orange">в 25 раз</h1>
              <p>
                выросло количество заказов еды с доставкой
                на дом в 2020 году в ресторанах по данным "Яндекса"
              </p>
            </div>
            <div class="inner">
              <h1 class="green">1200 руб</h1>
              <p>средний чек на доставку еды. И это только через “Яндекс”</p>
            </div>

          </div>
        </div>

      </div>
    </section>

    <section class="section s-mission">
      <div class="container">
        <h1>МИССИЯ ХОЧУ-ПОЕСТЬ</h1>

        <div class="point">
          <div class="point_bg">
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/point1.png" alt="">
            <span>1</span>
          </div>
          <p>
            Сделать доставку максимально быстрой. Мы должны
            просто заставить рестораны делать приготовление и
            доставку быстрее не в ущерб качеству.
          </p>
        </div>

        <div class="point">
          <div class="point_bg">
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/point2.png" alt="">
            <span>2</span>
          </div>
          <p>
            Сделать заказ еды простым и понятным – в
            два клика: первый клик – выбрать и добавить в пакет;
            второй – нажать на кнопку ЗАКАЗАТЬ.
          </p>
        </div>

        <div class="point">
          <div class="point_bg">
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/point1.png" alt="">
            <span>3</span>
          </div>
          <p>
            Предоставить возможность заказывать вкусную
            еду во всех городах вне зависимости от
            численности населения.
          </p>
        </div>

      </div>
    </section>

    <section class="section s-diagram">
      <div class="container">

        <div class="title">
          <h1>ХОЧУ-ПОЕСТЬ.РФ - ЭТО ТОЧНО ВЫГОДНО! МЫ УЗНАВАЛИ :)</h1>
          <p>
            По данным сайта beboss 67% клиентов общепита ранее не заказывали доставку еды,
            11% заказывают в любимых ресторанах, 22% заказывают только через сайты-агрегаторы.
            Поколение от 23 до 35 заказывают еду через агрегаторы в разы чаще - 35%.
          </p>
        </div>

        <div class="diagrams">
          <div class="diagram_box">
            <p>
              Старые клиенты - это стабильность,
              но с точки зрения теории бизнеса, стабильность -
              это показатель деградации.
            </p>
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/diagram1.svg" alt="">
          </div>

          <div class="diagram_box">
            <p>
              Наша задача привести Вам тех клиентов, которые заказывают
              на сервисах - это от 22 до 32% ЦА. На их привлечение Вы явно
              потратите больше. Новые клиенты - это рост. Вы же хотите расти?
            </p>
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/diagram2.svg" alt="">
          </div>

        </div>

        <div class="extra_info">
          <div class="info_box">
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/info1.png" alt="">

            <div class="reference">
              <a href="static/app/img/restaurants_services/doc.pdf">Узнать больше подробностей</a>
            </div>

          </div>
          <!--div class="info_box">
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/info2.png" alt="">
            <div class="reference">
              <a href="#">Получать больше заказов</a>
            </div>
          </div-->
          <div class="info_box">
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/info3.png" alt="">
            <div class="reference">
              <router-link to="/faq">FAQ</router-link>
            </div>
          </div>
        </div>

      </div>
    </section>

    <section class="section s-tendency">
      <div class="container">
        <div class="tendency_box">
          <div class="tendency_item">
            <iframe src="https://www.youtube.com/embed/PWzA6dMKEyo" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
          <div class="tendency_item">
            <iframe src="https://www.youtube.com/embed/Rnc6Pu0cFtk" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </section>

    <section class="section s-smi">
      <div class="container">

        <h1>СМИ О ХОЧУ-ПОЕСТЬ</h1>

        <div class="smi_about">
          <div class="slick-slide">
            <a href="https://www.the-village.ru/talks/business/58851-onlayn-agregator-dostavki-edy-istoriya-razvitiya" class="slick-slide" target="_blank">
              <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/smi1.png" alt="">
            </a>
          </div>
          <div class="slick-slide">
            <a class="slick-slide" tag="div" href="https://rfranch.ru/hochu_poest/" target="_blank">
              <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/smi2.png" alt="">
            </a>
          </div>
          <div class="slick-slide">
            <a class="slick-slide" tag="div" href="https://zhazhda.biz/cases/hochu-poest" target="_blank">
              <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/smi3.png" alt="">
            </a>
          </div>
          <div class="slick-slide">
            <a class="slick-slide" tag="div" href="https://bi-school.ru/kak-razvivat-svoj-biznes-putem-rasprostraneniya-franshizy/" target="_blank">
              <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/smi4.png" alt="">
            </a>
          </div>
          <div class="slick-slide">
            <a class="slick-slide" tag="div" href="https://promdevelop.ru/chto-vliyaet-na-pribyl-franshizy-sovety-dlya-franchajzi/" target="_blank">
              <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/smi5.png" alt="">
            </a>
          </div>
          <div class="slick-slide">
            <a class="slick-slide" tag="div" href="https://www.biz-club.ru/releases/missiya-nauchit-rossiyu-ekonomit-vremya-i-dengi-na-ede/" target="_blank">
              <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/smi6.png" alt="">
            </a>
          </div>
          <div class="slick-slide">
            <a class="slick-slide" tag="div" href="https://p-release.ru/dosug-turizm-i-otdyh/procent-golodayushchih-po-nocham-vyros-na-21" target="_blank">
              <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/smi7.png" alt="">
            </a>
          </div>
          <div class="slick-slide">
            <a class="slick-slide" tag="div" href="https://professionali.ru/Soobschestva/na_rabotu_v_svoj_biznes/istorija-razvitija-onlajn-agregatora/" target="_blank">
              <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/smi8.png" alt="">
            </a>
          </div>
          <div class="slick-slide">
            <a class="slick-slide" tag="div" href="https://multimillionaire.money/articles/4682/" target="_blank">
              <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/smi9.png" alt="">
            </a>
          </div>
          <div class="slick-slide">
            <a class="slick-slide" tag="div" href="https://www.kom-dir.ru/question/105-strategiyu-razvitiya-malogo-biznesa" target="_blank">
              <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/smi10.png" alt="">
            </a>
          </div>
        </div>

        <h1>ПОЛЕЗНЫЕ МАТЕРИАЛЫ</h1>

        <div class="references">

          <div class="reference_box">
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/Arrow.svg" alt="">
            <router-link to="/targetolog">Зачем нужен таргетолог в ресторане?</router-link>
          </div>

          <div class="reference_box">
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/Arrow.svg" alt="">
            <router-link to="/seasonality">Как бороться с сезонностью в ресторанном бизнесе?</router-link>
          </div>

          <div class="reference_box">
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/Arrow.svg" alt="">
            <router-link to="/development">Развитие ресторана по франшизе</router-link>
          </div>

          <div class="reference_box">
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/Arrow.svg" alt="">
            <router-link to="/secrets">Секреты скрытого маркетинга</router-link>
          </div>

          <div class="reference_box">
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/Arrow.svg" alt="">
            <router-link to="/profit">Почему ресторанам выгодно сотрудничество с агрегаторами доставки еды?</router-link>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import axios from '@/router/http'
import Inputmask from 'inputmask'
export default {
  name: 'forRestaurants',
  props: ['city', 'auth', 'geo'],
  data () {
    return {
      restaurant_name: null,
      web: null,
      checkbox: false,
      checkbox2: false
    }
  },
  created () {
    Inputmask().remove(document.getElementById('input'))
    setTimeout(() => { Inputmask().mask(document.querySelectorAll('input')) }, 500)
    $('.smi_about').slick({
      dots: false,
      arrows: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 10000,
      swipeToSlide: true,
      speed: 500,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            autoplaySpeed: 400
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            autoplaySpeed: 400
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            autoplaySpeed: 400
          }
        }
      ]
    })
  },
  methods: {
    sendRest () {
      if (!this.auth.name) alert('Вам необходимо указать имя')
      else if (!this.auth.phone && !this.auth.email) alert('Вам необходимо указать телефон или email')
      else if (!this.restaurant_name) alert('Вы забыли указать название ресторана')
      else if (!this.checkbox || !this.checkbox2) alert('Вам необходимо принять все условия')
      else {
        setTimeout(() => {
          var formData = new FormData()
          formData.append('crm', '13')
          formData.append('pipe', '26')
          formData.append('status', '139')
          formData.append('contact[name]', this.auth.name)
          formData.append('contact[256]', this.auth.phone)
          formData.append('contact[257]', this.auth.email)
          formData.append('contact[272]', this.city.name)
          formData.append('lead[name]', this.restaurant_name)
          formData.append('contact[263]', this.auth.phone)
          formData.append('contact[264]', this.auth.email)
          formData.append('contact[258]', this.city.name)
          formData.append('contact[265]', this.web)
          axios.post('https://hp.v-avtoservice.com/api/import-lead',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          )
        }, 1)
        var formData = new FormData()
        formData.append('name', this.auth.name)
        formData.append('phone', this.auth.phone)
        formData.append('email', this.auth.email)
        formData.append('restaurant_name', this.restaurant_name)
        formData.append('web', this.web)
        formData.append('uid', this.auth.uid)
        axios.post('https://lk.when-hungry.com/mobile/new-restaurant',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(response => {
          if (response.data.status === 'error') {
            alert(response.data.text)
          } else if (parseInt(response.data.gos)) {
            window.location.href = '/lk/restaurant/' + response.data.id
            /*
            this.$router.push({
              name: 'userRestaurant',
              params: { id: response.data.id }
            })
            */
          } else {
            alert('Ваши контактные данные уже были в системе, ресторан привязан к ним, для управления рестораном - авторизуйтесь, если забыли пароль - восстановите')
          }
        })
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/forRestaurants.vue